<template>
    <div class="navbar">
        <nav class="deep-purple darken-1">
            <div class="container">
                <router-link :to="{name:'GMap'}" class="brand-logo left">GeoPersonen</router-link>
                <ul class="right">
                    <li v-if="!user"><router-link :to="{name:'SignUp'}">Registrieren</router-link></li>
                    <li  v-if="!user"><router-link :to="{name:'Login'}">Anmelden</router-link></li>
                    <li v-if="user"><a>{{user.email}}</a></li>
                    <li v-if="user"><a @click="logout">Ausloggen</a></li>
                </ul>
            </div>
        </nav>

    </div>
</template>

<script>
    import firebase from 'firebase'

    export default {
        name: "Navbar",
        data() {
            return {
                user:null
            }
        },
        methods: {
            logout() {
               firebase.auth().signOut().then(()=>{
                   this.$router.push({ name: 'Login' })
               })
            }
        },
        created() {
            //wird immer gefired wenn es eine Aenderng beim User gab
            firebase.auth().onAuthStateChanged((user)=>{
                if (user){
                    this.user=user
                }
                else{
                   this.user=null
                }
            })
        }
    }
</script>

<style scoped>

</style>
